/*
 * Cart drawer upsell: fills the upsell row with Shopify recommendations
 * when there are no curated 'Pairs with' products to show.
 * Load with defer after cart-drawer-triggers.js.
 */
(function () {
  if (window.cartDrawerUpsellLoaded) return;
  window.cartDrawerUpsellLoaded = true;

  var MAX_SUGGESTIONS = 3;
  var busy = false;
  var timer = null;

  function getContainer() {
    return document.querySelector('cart-drawer [data-upsell]');
  }

  function getList(container) {
    return container ? container.querySelector('[data-upsell-list]') : null;
  }

  function getJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function absoluteUrl(url) {
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function imageUrl(product) {
    var image = product.featured_image;
    var src = typeof image === 'string' ? image : (image && image.src) || '';
    if (!src) return '';
    var clean = absoluteUrl(src);
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function formatPrice(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function buildRow(product) {
    var url = '/products/' + product.handle;
    var hasOptions = product.variants.length > 1;

    var li = document.createElement('li');
    li.className = 'cart-drawer__upsell-item';

    var image = document.createElement('a');
    image.href = url;
    image.className = 'cart-drawer__upsell-image';
    image.tabIndex = -1;
    image.setAttribute('aria-hidden', 'true');
    var src = imageUrl(product);
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.width = 60;
      img.height = 60;
      img.loading = 'lazy';
      image.appendChild(img);
    }

    var details = document.createElement('div');
    details.className = 'cart-drawer__upsell-details';

    var vendor = document.createElement('p');
    vendor.className = 'cart-drawer__upsell-vendor';
    vendor.textContent = product.vendor || '';

    var name = document.createElement('a');
    name.href = url;
    name.className = 'cart-drawer__upsell-name';
    name.textContent = product.title;

    var price = document.createElement('p');
    price.className = 'cart-drawer__upsell-price';
    price.textContent = formatPrice(product.price);

    details.appendChild(vendor);
    details.appendChild(name);
    details.appendChild(price);

    li.appendChild(image);
    li.appendChild(details);

    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.className = 'cart-drawer__upsell-form';

      if (hasOptions) {
      var select = document.createElement('select');
      select.name = 'id';
      select.className = 'cart-drawer__upsell-select';
      select.setAttribute('aria-label', 'Choose an option for ' + product.title);

      product.variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title + (variant.available ? '' : ' (sold out)');
        option.disabled = !variant.available;
        option.setAttribute('data-price', formatPrice(variant.price));
        select.appendChild(option);
      });

      var firstAvailable = product.variants.findIndex(function (v) { return v.available; });
      if (firstAvailable > -1) select.selectedIndex = firstAvailable;

      price.textContent = select.options[select.selectedIndex].getAttribute('data-price');

      select.addEventListener('change', function () {
        var chosen = select.options[select.selectedIndex];
        price.textContent = chosen.getAttribute('data-price');
      });

      form.appendChild(select);
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = product.variants[0].id;
      form.appendChild(input);
    }

    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'button button--secondary cart-drawer__upsell-button';
    button.textContent = 'Add';
    form.appendChild(button);

    li.appendChild(form);
    return li;
  
  }

  function getRecommendations(productId) {
    return getJson('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function (data) { return data.products || []; })
      .catch(function () { return []; });
  }

  function getFullProduct(handle) {
    return getJson('/products/' + handle + '.js').catch(function () { return null; });
  }

  function findSuggestions(cartItems) {
    var seen = {};
    cartItems.forEach(function (item) { seen[item.product_id] = true; });

    var sources = cartItems.slice(0, 2);

    return Promise.all(sources.map(function (item) {
        return getRecommendations(item.product_id);
      }))
      .then(function (lists) {
        var handles = [];
        lists.forEach(function (list) {
          list.forEach(function (p) {
            if (handles.length >= MAX_SUGGESTIONS + 2 || seen[p.id]) return;
            seen[p.id] = true;
            handles.push(p.handle);
          });
        });
        return Promise.all(handles.map(getFullProduct));
      })
      .then(function (products) {
        return products
          .filter(function (p) { return p && p.available && p.variants && p.variants.length; })
          .slice(0, MAX_SUGGESTIONS);
      });
  }

  function render(container, products) {
    var list = getList(container);
    if (!list) return;
    list.innerHTML = '';
    products.forEach(function (p) { list.appendChild(buildRow(p)); });
    container.hidden = products.length === 0;
  }

  function refresh() {
    if (busy) return;
    var container = getContainer();
    if (!container) return;

    getJson('/cart.js')
      .then(function (cart) {
        var signature = cart.items.map(function (i) { return i.product_id; }).join(',');
        if (container.getAttribute('data-signature') === signature) return;
        container.setAttribute('data-signature', signature);

        if (cart.items.length === 0) {
          container.hidden = true;
          return;
        }

        // If the curated 'Pairs with' products rendered, leave them in place
        var list = getList(container);
        if (list && list.children.length > 0) {
          container.hidden = false;
          return;
        }

        busy = true;
        return findSuggestions(cart.items)
          .then(function (products) { render(container, products); })
          .finally(function () { busy = false; });
      })
      .catch(function (error) {
        busy = false;
        console.error('Cart drawer upsell: could not load suggestions', error);
      });
  }

  // Re-run whenever the drawer re-renders (after an add, quantity change or removal)
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return el && el.closest && el.closest('cart-drawer');
    });
    if (!relevant) return;
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  });

  observer.observe(document.body, { childList: true, subtree: true });
  refresh();
})();